import { Loader } from '../../../_core/loader.component';
import { useRequestWithToken } from '../../../domains/request/request.service';
import { IAuthorizedRequestPageWrapper } from './request-page-auth-wrapper.types';
import ErrorPage from '../../InfoPages/error.page';
import { RequestPageContainer } from '../request-page.container';
import AlertPage from '../../InfoPages/alert.page';

export const TokenAccessRequestPageContainer = ({
  isPrintView,
  requestId,
  token
}: IAuthorizedRequestPageWrapper & { isPrintView?: boolean; token: string }) => {
  const { requestResponse, loading, error } = useRequestWithToken({ ignoreStatus: isPrintView, requestId, token });

  if (error?.message.toLowerCase().includes('invalid token')) return <ErrorPage>Invalid access token</ErrorPage>;

  if (!requestResponse?.request)
    if (loading) return <Loader />;
    else if (requestResponse?.error) return <AlertPage>{requestResponse.error}</AlertPage>;
    else return <ErrorPage>Request not found</ErrorPage>;

  if (!isPrintView && requestResponse.request.deletedAt) return <ErrorPage>Request has been archived</ErrorPage>;

  return <RequestPageContainer clientMode request={requestResponse?.request} token={token} isPrintView={isPrintView} />;
};
